import { Product } from '../types';

const STORAGE_KEY = 'inventory';

export const getInventory = (): Product[] => {
  const data = localStorage.getItem(STORAGE_KEY);
  const inventory: Product[] = data ? JSON.parse(data) : [];
  // Remove products with quantity <= 0 (cleanup of old state)
  const cleaned = inventory.filter(item => (item?.quantity ?? 0) > 0);
  if (cleaned.length !== inventory.length) {
    saveInventory(cleaned);
  }
  return cleaned;
};

export const saveInventory = (inventory: Product[]): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(inventory));
};

export const getProductById = (id: string): Product | undefined => {
  const inventory = getInventory();
  return inventory.find(product => product.id === id);
};

export const addProduct = (product: Product): void => {
  const inventory = getInventory();
  inventory.push(product);
  saveInventory(inventory);
};

export const updateProduct = (product: Product): void => {
  const inventory = getInventory();
  const index = inventory.findIndex(p => p.id === product.id);
  
  if (index !== -1) {
    inventory[index] = {
      ...product,
      lastUpdated: new Date().toISOString()
    };
    saveInventory(inventory);
  }
};

export const decreaseQuantity = (id: string, amount: number = 1): void => {
  const inventory = getInventory();
  const index = inventory.findIndex(p => p.id === id);
  
  if (index !== -1) {
    const newQuantity = Math.max(0, inventory[index].quantity - amount);
    if (newQuantity <= 0) {
      // Remove product from stock
      inventory.splice(index, 1);
      saveInventory(inventory);
    } else {
      inventory[index] = {
        ...inventory[index],
        quantity: newQuantity,
        lastUpdated: new Date().toISOString()
      };
      saveInventory(inventory);
    }
  }
};

export const increaseQuantity = (id: string, amount: number = 1): void => {
  const inventory = getInventory();
  const index = inventory.findIndex(p => p.id === id);
  
  if (index !== -1) {
    inventory[index] = {
      ...inventory[index],
      quantity: inventory[index].quantity + amount,
      lastUpdated: new Date().toISOString()
    };
    saveInventory(inventory);
  }
};

export const getLowStockProducts = (threshold: number = 5): Product[] => {
  const inventory = getInventory();
  return inventory.filter(product => product.quantity < threshold);
}; 